import PaginationRequest from '@/common/pagination/entities/pagination-request'

export default class StakeholdersRequest {

  public text = ''
  public paging: PaginationRequest = new PaginationRequest()
}
